// CRIO_SOLUTION_AND_STUB_START_MODULE_REGISTER
// CRIO_SOLUTION_AND_STUB_END_MODULE_REGISTER
import Register from './components/Register'
// import ipConfig from './ipConfig.json'
// CRIO_SOLUTION_AND_STUB_START_MODULE_LOGIN
import { Route, Switch } from 'react-router-dom'
import Login from './components/Login'
import Products from './components/Products'
// CRIO_SOLUTION_AND_STUB_END_MODULE_LOGIN
// CRIO_SOLUTION_START_MODULE_CART
import Checkout from './components/Checkout'
// CRIO_SOLUTION_END_MODULE_CART
// CRIO_SOLUTION_START_MODULE_CHECKOUT
import Thanks from './components/Thanks'
// CRIO_SOLUTION_END_MODULE_CHECKOUT
// CRIO_SOLUTION_START_MODULE_TERMS_OF_SERVICE
import TermsOfService from './components/TermsOfService'
// CRIO_SOLUTION_END_MODULE_TERMS_OF_SERVICE
// CRIO_SOLUTION_START_MODULE_PRIVACY_POLICY
import AboutUs from './components/AboutUs'
// CRIO_SOLUTION_END_MODULE_PRIVACY_POLICY
// CRIO_SOLUTION_START_MODULE_ABOUT_US
import PrivacyPolicy from './components/PrivacyPolicy'
// CRIO_SOLUTION_END_MODULE_ABOUT_US

export const config = {
  // endpoint: `http://${ipConfig.workspaceIp}:8082/api/v1`,
  // CRIO_SOLUTION_START_MODULE_DEPLOYMENT
  // endpoint: `https://crio-qkart-backend-qa.herokuapp.com/api/v1`,
  endpoint: `https://qkart-qa-backend.labs.crio.do/api/v1`,
  // CRIO_SOLUTION_END_MODULE_DEPLOYMENT
}

function App() {
  return (
    <div className="App">
      {/* TODO: CRIO_TASK_MODULE_LOGIN - To add configure routes and their mapping */}
      {/* CRIO_SOLUTION_START_MODULE_LOGIN */}
      <Switch>
        <Route path="/register">
          {/* CRIO_SOLUTION_END_MODULE_LOGIN */}
          <Register />
          {/* CRIO_SOLUTION_START_MODULE_LOGIN */}
        </Route>
        {/* CRIO_SOLUTION_END_MODULE_LOGIN */}
        {/* CRIO_SOLUTION_START_MODULE_LOGIN */}
        {/* TODO: CRIO_TASK_MODULE_REGISTER - To add route for /login */}
        <Route path="/login">
          <Login />
        </Route>
        {/* CRIO_SOLUTION_END_MODULE_LOGIN */}
        {/* CRIO_SOLUTION_START_MODULE_LOGIN */}
        <Route exact path="/">
          <Products />
        </Route>
        {/* CRIO_SOLUTION_END_MODULE_LOGIN */}
        {/* CRIO_SOLUTION_START_MODULE_CART */}
        <Route path="/checkout">
          <Checkout />
        </Route>
        {/* CRIO_SOLUTION_END_MODULE_CART */}
        {/* CRIO_SOLUTION_START_MODULE_CHECKOUT */}
        <Route path="/thanks">
          <Thanks />
        </Route>
        {/* CRIO_SOLUTION_END_MODULE_CHECKOUT */}
        {/* CRIO_SOLUTION_START_MODULE_TERMS_OF_SERVICE*/}
        <Route exact path="/terms-of-service">
          <TermsOfService />
        </Route>
        {/* CRIO_SOLUTION_END_MODULE_TERMS_OF_SERVICE */}
        {/* CRIO_SOLUTION_START_MODULE_PRIVACY_POLICY*/}
        <Route exact path="/privacy-policy">
          <PrivacyPolicy />
        </Route>
        {/* CRIO_SOLUTION_END_MODULE_PRIVACY_POLICY */}
        {/* CRIO_SOLUTION_START_MODULE_ABOUT_US*/}
        <Route exact path="/aboutus">
          <AboutUs />
        </Route>
        {/* CRIO_SOLUTION_END_MODULE_ABOUT_US*/}
        {/* CRIO_SOLUTION_START_MODULE_LOGIN */}
      </Switch>
      {/* CRIO_SOLUTION_END_MODULE_LOGIN */}
    </div>
  )
}

export default App
